var render = function render(){var _vm=this,_c=_vm._self._c;return _c('footer',{attrs:{"id":"footer"}},[(_vm.user)?_c('router-link',{staticClass:"report",attrs:{"to":{ name: 'report' }}},[_vm._v("Report A Bug")]):_vm._e(),_vm._m(0)],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"mediatalo",attrs:{"href":"http://360mediahouse.com","target":"_blank"}},[_c('img',{attrs:{"src":require("../assets/360mediahouse.png")}})])
}]

export { render, staticRenderFns }